module.exports = __webpack_public_path__ + "img/high-definition.7188c512.svg";